import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { removeAllFromCart, removeFromCart } from "../redux/cart/cartAction";

const Cart = () => {
  // Access cart data from the Redux store
  const cartData = useSelector((state) => state.cartData);

  // Initialize dispatch function from Redux
  const dispatch = useDispatch();

  // Calculate total amount in the cart
  let amount =
    cartData.length &&
    cartData.map((item) => item.price).reduce((prev, next) => prev + next);
  return (
    <div className="cart-page">
      <div className="cart-header">
        <Link to="/" className="back-link">
          ← Back to Products
        </Link>
        <button
          className="clear-cart-btn"
          onClick={() => dispatch(removeAllFromCart())}
        >
          🗑️ Clear Cart
        </button>
      </div>

      <h1 className="cart-title">🛒 Your Shopping Cart</h1>

      {cartData.length === 0 ? (
        <p className="empty-cart">
          😕 Your Cart is Empty!,{" "}
          <Link style={{ textDecoration: "none" }} to="/">
            Continue Shopping
          </Link>
        </p>
      ) : (
        <div className="cart-page-container">
          <table className="cart-table">
            <thead>
              <tr>
                <th>Image</th>
                <th>Name</th>
                <th>Category</th>
                <th>Price</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {cartData.map((item, index) => (
                <tr key={index}>
                  <td>
                    <img
                      src={item.image}
                      alt={item.title}
                      className="cart-img"
                    />
                  </td>
                  <td>{item.title}</td>
                  <td>{item.category}</td>
                  <td>${item.price}</td>
                  <td>
                    <button
                      className="remove-btn"
                      onClick={() => dispatch(removeFromCart(item.id))}
                    >
                      Remove
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="price-details">
            <h2>Order Summary</h2>
            <div className="adjust-price">
              <span>Subtotal</span>
              <span>${amount.toFixed(2)}</span>
            </div>
            <div className="adjust-price">
              <span>Discount</span>
              <span>-${(amount / 10).toFixed(2)}</span>
            </div>
            <div className="adjust-price">
              <span>Tax</span>
              <span>$0.00</span>
            </div>
            <div className="adjust-price total">
              <span>Total</span>
              <span>${(amount - amount / 10).toFixed(2)}</span>
            </div>
            <button className="checkout-btn">Proceed to Checkout</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Cart;
